import { __assign } from "tslib";
import { useCallback, useEffect, useRef } from 'react';
export function useUserRPC(_a) {
    var loading = _a.loading, iframeRef = _a.iframeRef, origin = _a.origin, rpcHandler = _a.rpcHandler;
    var messagesRef = useRef([]);
    var sendMessage = useCallback(function (message) {
        var _a, _b;
        var messageJSON = JSON.stringify(message);
        if (loading) {
            messagesRef.current.push(messageJSON);
        }
        else {
            (_b = (_a = iframeRef.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.postMessage(messageJSON, '*');
        }
    }, [loading, iframeRef]);
    var messageHandler = useCallback(function (e) {
        if (e.origin !== origin)
            return;
        var methodData;
        try {
            methodData = JSON.parse(e.data);
        }
        catch (_) {
            // Сообщение от другого источника, пропускаем
            return;
        }
        // Сообщение от другого источника, пропускаем
        if (!methodData.methodCall) {
            return;
        }
        rpcHandler === null || rpcHandler === void 0 ? void 0 : rpcHandler(__assign({}, methodData), function (params) {
            var _a;
            sendMessage({
                returnCall: true,
                params: [params],
                resultCallbackIndex: ((_a = methodData.resultCallbackIndex) === null || _a === void 0 ? void 0 : _a.__callbackId) || -1,
            });
        });
    }, [origin, rpcHandler, sendMessage]);
    useEffect(function () {
        window.addEventListener('message', messageHandler);
        return function () {
            window.removeEventListener('message', messageHandler);
        };
    }, [messageHandler]);
    useEffect(function () {
        if (!iframeRef || loading || messagesRef.current.length === 0) {
            return;
        }
        messagesRef.current.forEach(function (message) { var _a, _b; return (_b = (_a = iframeRef.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.postMessage(message, '*'); });
        messagesRef.current = [];
    }, [loading, iframeRef]);
    return { sendMessage: sendMessage };
}
